<template>
  <div class="text-standard">
    <!-- <div class="container mx-auto flex flex-col md:flex-row pt-10 md:pt-16">
      <div class="laptop:w-6/12 p-5 md:p-0 md:mx-8 laptop:p-0 md:w-3/6 lg:min-h-0 flex-grow" style="min-height:475px">
        <iframe v-if="youtubeEnabled" style="width:100%; min-height:475px" class="h-full"
                src="https://www.youtube.com/embed/f4kk17h4BZY?rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
        <iframe v-if="!youtubeEnabled" style="width:100%; min-height:475px" class="h-full"
                src="https://www.youtube-nocookie.com/embed/f4kk17h4BZY?rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
      </div>
      <div
        class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-1/2 text-standard justify-center flex flex-col">
        <h2
          class="text-standard fullhd:text-55px laptop:text-55px font-bold mb-12 md:w-full laptop:w-full md:text-4xl leading-normal laptop:leading-tight" v-html="$t('onestring.title')" />
        <div v-html="$t('onestring.subtitle')" />
      </div>
    </div> -->

    <div class="w-full bg-highlight bg-visualizer-medium laptop:bg-visualizer bg-center bg-cover relative">
      <video class="fullscreen hidden laptop:block" src="~/assets/img/video/onestring-2.mp4" playsinline autoplay muted
             loop />
      <video class="fullscreen block laptop:hidden" src="~/assets/img/video/onestring-1.mp4" playsinline autoplay muted
             loop />
      <div class="container h-full mx-auto relative">
        <div class="flex flex-col justify-around h-full laptop:w-6/12 w-full md:w-10/12 p-5 laptop:ml-24 md:ml-8 z-50">
          <div>
            <h3
              class="text-white text-4xl laptop:text-55xl md:w-3/4 md:text-4xl laptop:w-full font-bold leading-tight"
              v-html="$t('artag.hero')" />
          </div>
        </div>
      </div>
    </div>

    <Block2Cols>
      <template #col1>
        <MARSTitle font-size="md:text-45xl lg:text-45xl laptop:text-52xl"><div v-html="$t('artag.title-1')" /></MARSTitle>
        <p class="text-standard mt-4 mb-8" v-html="$t('artag.box-1')" />
      </template>
      <template #col2>
        <video src="~/assets/img/video/artag.mp4" playsinline autoplay muted loop />
      </template>
    </Block2Cols>

    <Block2Cols compact>
      <template #col1>
        <p class="text-standard mt-4 mb-8" v-html="$t('artag.box-2a')" />
      </template>
      <template #col2>
        <p class="text-standard mt-4 mb-8" v-html="$t('artag.box-2b')" />
      </template>
    </Block2Cols>

    <Block2Cols>
      <template #col1>
        <MARSTitle>{{ $t('artag.title-2') }}</MARSTitle>
      </template>
      <template #col2>
        <p v-html="$t('artag.intro')"></p>
      </template>
    </Block2Cols>

    <Block2Cols compact>
      <template #col1>
        <p v-html="$t('artag.description-1')"></p>
      </template>
      <template #col2>
        <p v-html="$t('artag.description-2')"></p>
      </template>
    </Block2Cols>

    <div
      class="w-full bg-center bg-cover mt-150px relative flex justify-center"
      style="background:linear-gradient(to bottom, #ebebeb 84%, #fff 84% 100%);"
    >
      <img
        loading="lazy"
        class="fullscreen hidden laptop:block"
        src="~/assets/img/artag/artag-explain.webp"
        style="max-height:80vh; height:auto; width:auto; max-width:100%; display:block; margin:auto;"
      >
    </div>

    <Block2Cols>
      <template #col1>
        <MARSTitle>{{ $t('artag.create-title') }}</MARSTitle>
        <p v-html="$t('artag.create-intro')"></p>
      </template>
      <template #col2>
        <ul>
          <li v-html="$t('artag.create-list-1')"></li>
          <li v-html="$t('artag.create-list-2')"></li>
          <li v-html="$t('artag.create-list-3')"></li>
          <li v-html="$t('artag.create-list-4')"></li>
          <li v-html="$t('artag.create-list-5')"></li>
        </ul>
      </template>
    </Block2Cols>

    <Block1Col>
      <MARSTitle>{{ $t('artag.examples') }}</MARSTitle>
    </Block1Col>

    <Block2Cols compact>
      <template #col1>
        <h3 class="example">{{ $t('artag.calzedonia-title') }}</h3>
        <p v-html="$t('artag.calzedonia-description')"></p>
      </template>
      <template #col2>
        <YouTubeVideo id="BacJiMpvfOs"></YouTubeVideo>
      </template>
    </Block2Cols>

    <Block2Cols reverse>
      <template #col1>
        <h3 class="example">{{ $t('artag.volotea-title') }}</h3>
        <p v-html="$t('artag.volotea-description')"></p>
      </template>
      <template #col2>
        <YouTubeVideo id="WKV6qabaFPg"></YouTubeVideo>
      </template>
    </Block2Cols>

    <Block2Cols>
      <template #col1>
        <h3 class="example">{{ $t('artag.eurozappa-title') }}</h3>
        <p v-html="$t('artag.eurozappa-description')"></p>
      </template>
      <template #col2>
        <YouTubeVideo id="GxLxUTeShKE"></YouTubeVideo>
      </template>
    </Block2Cols>

    <Block2Cols reverse>
      <template #col1>
        <h3 class="example">{{ $t('artag.bottegaveneta-title') }}</h3>
        <p v-html="$t('artag.bottegaveneta-description')"></p>
      </template>
      <template #col2>
        <YouTubeVideo id="o07SSxq3LmQ"></YouTubeVideo>
      </template>
    </Block2Cols>


    <div class="w-full bg-center bg-cover mt-150px relative">
      <img v-if="$i18n.locale != 'it'" loading="lazy" class="fullscreen hidden laptop:block w-full" src="~/assets/img/onestring/instructions_en_h.webp">
      <img v-if="$i18n.locale != 'it'" loading="lazy" class="fullscreen block laptop:hidden mx-auto" src="~/assets/img/onestring/instructions_en_v.webp">
      <img v-if="$i18n.locale == 'it'" loading="lazy" class="fullscreen hidden laptop:block w-full" src="~/assets/img/onestring/instructions_it_h.webp">
      <img v-if="$i18n.locale == 'it'" loading="lazy" class="fullscreen block laptop:hidden mx-auto" src="~/assets/img/onestring/instructions_it_v.webp">
    </div>


    <Block2Cols>
      <template #col1>
        <img id="fullscreen_flyer" loading="lazy" src="~/assets/img/onestring/flyer.webp">
      </template>
      <template #col2>
        <MARSTitle font-size="md:text-45xl lg:text-45xl laptop:text-52xl"><div v-html="$t('artag.try-it')" /></MARSTitle>
        <p class="text-standard mt-4" v-html="$t('artag.box-3')" />
        <p class="text-standard mt-4 mb-8"><template v-html="$t('artag.box-4')" />
          <img class="inline-block mx-8 w-8" loading="lazy" src="~/assets/img/onestring/btn-fullscreen.svg" onclick="document.querySelector('#fullscreen_flyer').requestFullscreen()">
          <a href="/download/MyARStudio_OneString_flyer.webp" download="MyARStudio_OneString_flyer.webp" title="Download OneString ProductTag flyer"><img class="inline-block w-8" loading="lazy" src="~/assets/img/onestring/btn-download.svg"></a>
        </p>
      </template>
    </Block2Cols>

    <Block2Cols>
      <template #col1>
        <p v-html="$t('artag.conclusion')"></p>
      </template>
      <template #col2>
        <ActionButton :href="$t('links.guide-artag')" :value="$t('artag.documentation-btn')" :bg="Colors.highlight" :fg="Colors.white" />
      </template>
    </Block2Cols>

    <div class="pt-10" />
    
  </div>
</template>

<script setup lang="ts">
import MARSTitle from '@/components/MARSTitle.vue'
import Box from '@/components/Box.vue'
import { useIubenda } from 'mars-iubenda-vite';

const {youtubeEnabled} = useIubenda()
// TODO: is the video at the top of the page the right one? I remember another video where Pegolo rides a bike and prepares for the Milan week?
</script>

<style scoped>
.console {
  background-image: url("~/assets/img/examples/anamorphic-hero.webp");
}

video.fullscreen {
  position: absolute;
  z-index: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

h3.example {
  @apply text-3xl text-highlight font-bold mt-2;
}
</style>
